import { Service } from '@estee/elc-service';
import { ACCOUNT_SIDEBAR_LOYALTY } from '@estee/elc-service-view-names';
import { ServiceInitializer } from '@estee/elc-universal-utils';

import { IServiceAppConfig } from '~domain/entities/IConfig';
import { LoyaltyServiceStartedUseCase } from '~use-cases/LoyaltyServiceStartedUseCase';

import { diContainer, serviceNames } from './diContainer';

const { name, version } = __serviceInfo__;

export class LoyaltyService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);

        this.registerView(
            ACCOUNT_SIDEBAR_LOYALTY,
            () =>
                import(
                    /* webpackChunkName: 'LoyaltyTier' */
                    '../exported/loyalty-tier/LoyaltyTier'
                ),
            () => diContainer.get(serviceNames.loyaltyTierViewController)
        );
    }

    public async start(appConfig: IServiceAppConfig) {
        const service = await super.start(appConfig);
        const requestedBuidConfigs = ['brand.id', 'language', 'region'];

        const useCase = new LoyaltyServiceStartedUseCase({
            appConfig,
            requestedBuidConfigs
        });

        await useCase.execute();

        return service;
    }
}
